module.exports = __webpack_public_path__ + "img/카지노칩.8aed107b.png";